// Portal sidebar icons - every "me" page (/my-orders, /my-invoices,
// /my-addresses, /me and the start page /my-feelgood) shows the left
// navigation list, and each entry gets the SAME lucide SVG the partner area
// uses for its tiles (Gerald, 2026-11).
//
// The sidebar itself stays untouched: frappe renders the items from the
// Portal Menu Items plus the hardcoded "My Account" row
// (templates/includes/web_sidebar.html) - the icons are only ADDED here,
// client side, keyed by route prefix. A menu entry without a map entry keeps
// its plain look (so the shop sidebars and any future menu row are never
// polluted with a wrong icon).

(function () {
	// Route -> inline SVG, 1:1 the icons of the partner area tiles
	// (www/partnerbereich.html, "Mein Feelgood" section).
	var ICONS = {
		"/my-invoices":
			'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>',
		"/my-orders":
			'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>',
		"/my-addresses":
			'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0Z"/><circle cx="12" cy="10" r="3"/></svg>',
		"/me": '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>',
	};

	function iconFor(href) {
		var path = String(href || "").split("#")[0].split("?")[0];
		if (path.indexOf("/") !== 0) {
			return null;
		}
		var routes = Object.keys(ICONS);
		for (var i = 0; i < routes.length; i++) {
			var route = routes[i];
			if (path === route || path.indexOf(route + "/") === 0) {
				return ICONS[route];
			}
		}
		return null;
	}

	frappe.ready(function () {
		var links = document.querySelectorAll(
			".web-sidebar .sidebar-items .sidebar-item a"
		);
		for (var i = 0; i < links.length; i++) {
			var link = links[i];
			var href = link.getAttribute("href") || "";
			// Align "Mein Konto" / "My Account" to "Konto" (Gerald, 2026-11)
			if (href === "/me" || href.indexOf("/me") === 0) {
				for (var j = 0; j < link.childNodes.length; j++) {
					var node = link.childNodes[j];
					if (node.nodeType === 3 && node.textContent.trim()) {
						node.textContent = " Konto";
					}
				}
			}
			if (link.querySelector(".fp-sb-icon")) {
				continue;
			}
			var svg = iconFor(href);
			if (!svg) {
				continue;
			}
			var icon = document.createElement("span");
			icon.className = "fp-sb-icon";
			icon.innerHTML = svg;
			link.insertBefore(icon, link.firstChild);
		}
	});
})();
